import React from "react";

// interface CommonConfirmationModalProps {
//   id: string;
//   buttonId?: string;
//   onConfirm: () => void;
//   text?: string;
//   showHeader?: boolean;
//   disable?: boolean;
//   icon?: React.ReactNode;
//   loading?: boolean;
//   variant?: "danger" | "warning" | "success" | "info" | "primary";
//   message?: string;
// }

const variantStyles = {
  danger: {
    background: "#ffe2e5",
    color: "#f64e60",
  },
  success: {
    background: "#e6f4ea",
    color: "#28a745",
  },
  warning: {
    background: "#fff4de",
    color: "#ffa800",
  },
  info: {
    background: "#e1f0ff",
    color: "#3699ff",
  },
  primary: {
    background: "#cfe2ff",
    color: "#0d6efd",
  },
};

const CommonConfirmationModal = ({
  id,
  buttonId = "cancel-button",
  onConfirm,
  text = "Cancellation",
  icon,
  showHeader = true,
  loading = false,
  disable = false,
  variant = "danger",
  message = "",
}) => {
  return (
    <div className="modal fade" id={id}>
      <div
        className="modal-dialog modal-dialog-centered modal-sm"
        // style={{ width: "450px" }}
      >
        <div className="modal-content">
          <form>
            <div className="modal-body text-center">
              <span
                className={`bg-soft-${variant} text-${variant}`}
                style={{
                  width: "60px",
                  height: "60px",
                  borderRadius: "5px",
                  margin: "0 auto 24px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "40px",
                  ...variantStyles[variant],
                }}
              >
                {icon ? icon : <i className="ti ti-trash-x" />}
              </span>
              {showHeader && (
                <h4 style={{ marginBottom: "10px", fontSize: "20px" }}>
                  Confirm <span>{text}</span>
                </h4>
              )}
              {message.length ? (
                <p className="mb-4">{message}</p>
              ) : (
                <p className="mb-4">
                  Are you sure you want to {text} this item?
                </p>
              )}

              <div className="d-flex justify-content-center">
                <div
                  className="btn btn-light me-3 btn-sm"
                  data-bs-dismiss="modal"
                  id={buttonId}
                >
                  No
                </div>
                <button
                  onClick={onConfirm}
                  type="button"
                  disabled={disable || loading}
                  className={`btn btn-${variant} btn-sm`}
                >
                  {loading ? (
                    <span className="d-flex align-items-center">
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Loading...
                    </span>
                  ) : (
                    "Confirm"
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CommonConfirmationModal;
